import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AccordionItem } from './Accordion';
import { BuyButton } from './BuyButton';
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/oN7Lq6kRtp58vZdgo48iJc/IMG_5061.jpg',
    title: '🎁 BONO 1: Biblioteca de 30 Ejercicios Específicos para Laterales',
    content: ['Técnica y control', 'Defensa y duelos', 'Centros y finalización', 'Perfil corporal', 'Escaneo y percepción', 'Resistencia específica', 'Organización y progresiones', 'Errores frecuentes']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/df1yxTtJFo6oMoEPpukUZY/IMG_5062.jpg',
    title: '🎁 BONO 2: Sistema de Autoanálisis Profesional',
    content: ['Evaluación partido a partido', 'Duelos ganados y perdidos', 'Coberturas', 'Participación ofensiva', 'Participación defensiva', 'Centros y pases clave', 'Errores de posicionamiento', 'Métricas de rendimiento', 'Plan de mejora semanal']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/7g1PgKZgQfEtsC1291Zjzd/IMG_5063.jpg',
    title: '🎁 BONO 3: Preparación Física Específica del Lateral',
    content: ['RSA (Repeated Sprint Ability)', 'Sprint repetido', 'Aceleración', 'Cambios de dirección', 'Resistencia específica para la posición', 'Prevención de lesiones', 'Entrenamiento en cancha', 'Planificación semanal']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/e91SJFrUZddD52hPbfLUVJ/IMG_5064.jpg',
    title: '🎁 BONO 4: Guía para Ganar el Puesto',
    content: ['Qué observan los entrenadores en un lateral', 'Cómo destacar en entrenamientos', 'Errores que te dejan en el banco', 'Cómo rendir en pruebas y visorias', 'Cómo generar confianza en entrenadores y compañeros', 'Mentalidad para competir por la titularidad']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/7M1WWzSZ1eFKcYHhDB2k9K/IMG_5065.jpg',
    title: '🎁 BONO 5: Perfilador de Laterales',
    content: ['Descubrí qué tipo de lateral sos y cómo potenciar tu juego. Incluye:', 'Test de evaluación completo', 'Perfil defensivo', 'Perfil ofensivo', 'Perfil interior', 'Perfil carrilero', 'Perfil constructor', 'Fortalezas y debilidades', 'Riesgos a corregir', 'Plan de mejora personalizado']
  }];
  return <section className="py-16 px-4 bg-[#f8f9fa]" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-29">
          <h2 className="text-3xl md:text-5xl text-[#1a3d1f] mb-4 uppercase" data-id="element-30">
            Bonos Exclusivos
          </h2>
          <p className="text-xl font-bold bg-[#84cc16] text-[#14321a] inline-block px-4 py-2 rounded-lg uppercase tracking-wide" data-id="element-31">
            GRATIS por el día de hoy
          </p>
        </motion.div>

        <div className="mb-10" data-id="element-32">
          {bonuses.map((bonus, index) => <AccordionItem key={index} title={bonus.title} content={bonus.content} image={bonus.image} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-33" />)}
        </div>

        <BuyButton data-id="element-34" />
      </div>
    </section>;
}